import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { waLink } from "@/utils/scroll";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function WhatsAppFloat() {
  const { content } = useContent();
  const intl = content?.settings?.whatsapp_intl;
  const href = waLink(intl, "Hello IPTV HUB, I need assistance with...");

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat with IPTV HUB on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-slate-900 shadow-[0_0_30px_rgba(37,211,102,0.5)]"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" aria-hidden="true" />
      <WhatsAppIcon className="relative h-7 w-7" />
      <span className="hidden md:flex absolute right-full mr-3 whitespace-nowrap items-center gap-2 rounded-full glass px-4 py-2 text-xs font-semibold text-slate-700">
        <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
        Online — instant reply
      </span>
    </motion.a>
  );
}
